var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 72,
    viewBox: "0 0 104 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1428 28.2857C96.5017 58.4465 71.9294 72 52.5559 72C33.1825 72 8 55.7095 8 38.359C8 21.0086 12.6244 10.2043 32.1126 3.51391C51.6008 -3.1765 91.784 -1.87508 94.1428 28.2857Z",
    fill: "#F7F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1043 18.06C56.8644 18.06 53.9922 21.3132 51.7139 23.5692C49.4356 21.3132 46.5634 18.06 41.3235 18.06C36.0836 18.0601 30.6636 23.0041 30.9335 30.0671C30.9335 40.0965 44.5207 48.9252 51.7139 53.94C58.907 48.9252 72.4942 40.0965 72.4942 30.0671C72.7641 23.0041 67.3441 18.0601 62.1043 18.06Z",
    fill: "url(#paint0_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25913 22.84C7.79513 22.84 7.28313 22.8 6.72313 22.72C6.17913 22.656 5.73113 22.576 5.37913 22.48V20.704C6.05113 20.912 6.77113 21.016 7.53913 21.016C8.65913 21.016 9.62713 20.832 10.4431 20.464C11.2751 20.096 11.9071 19.6 12.3391 18.976C12.7711 18.352 12.9871 17.664 12.9871 16.912C12.9871 15.888 12.6831 15.096 12.0751 14.536C11.4671 13.976 10.5631 13.68 9.36313 13.648L7.92313 14.008L7.41913 12.544C8.07513 12.432 8.72313 12.232 9.36313 11.944C10.2911 11.528 11.0111 11.008 11.5231 10.384C12.0351 9.744 12.2911 9.064 12.2911 8.344C12.2911 7.544 12.0431 6.96 11.5471 6.592C11.0671 6.224 10.4511 6.04 9.69913 6.04C8.99513 6.04 8.33113 6.16 7.70713 6.4C7.09913 6.64 6.57913 6.936 6.14713 7.288L5.30713 5.824C5.77113 5.376 6.52313 4.936 7.56313 4.504C8.61913 4.072 9.69113 3.856 10.7791 3.856C12.2991 3.856 13.5311 4.184 14.4751 4.84C15.4351 5.48 15.9151 6.456 15.9151 7.768C15.9151 8.92 15.4671 9.936 14.5711 10.816C13.6751 11.696 12.5791 12.368 11.2831 12.832C11.4431 12.816 11.6831 12.808 12.0031 12.808C13.4271 12.808 14.5791 13.168 15.4591 13.888C16.3551 14.608 16.8031 15.568 16.8031 16.768C16.8191 17.92 16.4751 18.952 15.7711 19.864C15.0831 20.792 14.0911 21.52 12.7951 22.048C11.4991 22.576 9.98713 22.84 8.25913 22.84Z",
    fill: "#8E8CEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.5451 18.06) rotate(127.736) scale(45.3696 54.4139)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330493,
    stopColor: "#CAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333117,
    stopColor: "#BAB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630108,
    stopColor: "#BBB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#9E9CFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a7eca808b5483c6ef27829c24a665b60.svg";
export { ForwardRef as ReactComponent };